import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';
import styles from './GraficoPedidosPorHora.module.css';

function GraficoPedidosPorHora({ pedidos, titulo = "Vendas por Hora" }) {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (!pedidos || pedidos.length === 0 || !chartRef.current) return;

    // Processar pedidos por hora
    const pedidosPorHora = {};
    pedidos.forEach(p => {
      if (!p.data_pedido) return;
      const hora = new Date(p.data_pedido).getHours();
      pedidosPorHora[hora] = (pedidosPorHora[hora] || 0) + 1;
    });

    // Criar arrays de labels e dados ordenados
    const labelsHora = Object.keys(pedidosPorHora).sort((a, b) => a - b).map(h => `${h}h`);
    const dataHora = labelsHora.map(label => {
      const hora = parseInt(label);
      return pedidosPorHora[hora] || 0;
    });

    // Destruir gráfico anterior se existir
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    // Criar novo gráfico
    chartInstance.current = new Chart(chartRef.current.getContext('2d'), {
      type: 'line',
      data: {
        labels: labelsHora,
        datasets: [{
          label: "Pedidos por Hora",
          data: dataHora,
          borderColor: '#d33333',
          backgroundColor: 'rgba(211, 51, 51, 0.1)',
          tension: 0.4,
          borderWidth: 3,
          fill: true,
          pointRadius: 4,
          pointBackgroundColor: '#d33333',
          pointBorderColor: '#fff',
          pointBorderWidth: 2,
          pointHoverRadius: 6
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            padding: 12,
            titleFont: {
              size: 14
            },
            bodyFont: {
              size: 13
            },
            callbacks: {
              label: function(context) {
                return `Pedidos: ${context.parsed.y}`;
              }
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              stepSize: 1,
              font: {
                size: 12
              }
            },
            grid: {
              color: 'rgba(0, 0, 0, 0.05)'
            }
          },
          x: {
            ticks: {
              font: {
                size: 12
              }
            },
            grid: {
              display: false
            }
          }
        }
      }
    });

    // Cleanup ao desmontar
    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [pedidos]);

  return (
    <div className={styles.graficoContainer}>
      <div className={styles.graficoHeader}>
        <h3 className={styles.graficoTitulo}>{titulo}</h3>
        <p className={styles.graficoDescricao}>Descubra em quais horários há mais movimento</p>
      </div>
      <div className={styles.graficoWrapper}>
        <canvas ref={chartRef}></canvas>
      </div>
    </div>
  );
}

export default GraficoPedidosPorHora;
